'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../tslib.es6-CZ43up4V.js');
const designSystem = require('@zapier/design-system');
const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_mhk2s_1";
const titleLabelWrapper = "_title-label-wrapper_mhk2s_85";
const title = "_title_mhk2s_85";
const label = "_label_mhk2s_116";
const styles = {
	root: root,
	titleLabelWrapper: titleLabelWrapper,
	title: title,
	label: label
};

const SelectionChip = (_a) => {
  var _b, _c, _d;
  var { children, className, id, isDisabled = false, label, size: sizeFromProps = "small", style, textValue, title, variant: variantFromProps = "primary" } = _a, props = tslib_es6.__rest(_a, ["children", "className", "id", "isDisabled", "label", "size", "style", "textValue", "title", "variant"]);
  const tagGroupContext = React.useContext(reactAriaComponents.TagGroupContext);
  const size = (_b = tagGroupContext.size) !== null && _b !== void 0 ? _b : sizeFromProps;
  const variant = (_c = tagGroupContext.variant) !== null && _c !== void 0 ? _c : variantFromProps;
  const getTextValue = () => {
    if (textValue)
      return textValue;
    return label ? `${title} ${label}` : title;
  };
  return React__default.default.createElement(reactAriaComponents.Tag, Object.assign({}, props, { className: clsx.clsx(className, styles.root), "data-selectable": (_d = tagGroupContext === null || tagGroupContext === void 0 ? void 0 : tagGroupContext.selectionMode) !== null && _d !== void 0 ? _d : void 0, "data-size": size, "data-variant": variant, "data-zds": true, id, isDisabled, style, textValue: getTextValue() }), (tagRenderProps) => React__default.default.createElement(
    React__default.default.Fragment,
    null,
    typeof children === "function" ? children(tagRenderProps) : children,
    title && React__default.default.createElement(
      "div",
      { className: styles.titleLabelWrapper, "data-zds": true },
      React__default.default.createElement("span", { className: styles.title, "data-zds": true }, title),
      React__default.default.createElement("span", { className: styles.label, "data-zds": true }, label)
    )
  ));
};
const SelectionChipServiceIcon = ({ serviceName, src }) => React__default.default.createElement(designSystem.ServiceIcon, { hasBorder: false, size: "large", serviceName, src });
const SelectionChipIcon = ({ name }) => React__default.default.createElement(designSystem.Icon, { name });

exports.SelectionChip = SelectionChip;
exports.SelectionChipIcon = SelectionChipIcon;
exports.SelectionChipServiceIcon = SelectionChipServiceIcon;
//# sourceMappingURL=SelectionChip.cjs.js.map
